module.exports = __webpack_public_path__ + "img/syukyaku-co-001.c3d95e81.jpg";